/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ==============================================================================
 * FILE: frontend/src/pages/landing/Landing.tsx
 * PURPOSE: Product landing page (marketing) for NQH-Bot Platform
 * SDLC FRAMEWORK VERSION: 6.1.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 2: Milestone-Gated Roadmaps
 *
 * DATE: 2025-12-28
 * COMPLIANCE: SDLC 6.3.1 Stage 06 (BUILD) + Vietnamese UX Standards
 * CTO MANDATE: Product-focused landing with token-only styling
 *
 * @business-context
 * - Domain: Go-to-market, product positioning, Vietnamese F&B WFM
 * - Impact: Conversion funnel entry point (visit → login)
 * - Stakeholders: Sales/BD, Product, End users
 *
 * @technical-architecture
 * - Layer: Presentation Layer, Page Component
 * - Pattern: Component composition, CSS Modules, i18n
 * - Dependencies: react-i18next, react-router
 */

import React from "react";
import styles from "./Landing.module.css";
import {
  LandingHeader,
  Hero,
  Features,
  UseCases,
  ProductShowcase,
  CTASection,
  LandingFooter,
} from "./components";

export const Landing: React.FC = () => {
  return (
    <div className={styles.page}>
      <LandingHeader />
      <main className={styles.main}>
        <section className={styles.section}>
          <Hero />
        </section>

        <section id="features" className={styles.section}>
          <Features />
        </section>

        <section id="use-cases" className={styles.section}>
          <UseCases />
        </section>

        <section id="product" className={styles.section}>
          <ProductShowcase />
        </section>

        <section id="contact" className={styles.section}>
          <CTASection />
        </section>
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
